import React, { useState, memo, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  IconButton,
  MenuItem,
  TextField,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  Slide,
  Checkbox,
  Grid,
  FormControlLabel,
  FormControl,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import InputField from "../../../../reusable-component/InputField";
import { useAxios } from "../../../../contexts/AxiosProvider";
import { InstrumentApi } from "../../../../services/InstrumentApi";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";
import { getEnvironmentConfig } from "../../../../constants/CloudConstant";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const NodeModalPreprocessInstrumentFile = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  userData,
  workflow,
}) => {
  console.log(workflow);
  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios();
  const INITIALSTATE = {
    alias: "",
    sample_view: true,
    instrument_name: "",
    initial_path: `${getEnvironmentConfig().BUCKET_PATH}/${
      workflow.engagement.clientEntity.domainEntity.domainName
    }/${workflow.engagement.clientEntity.clientName}/${
      workflow.engagement.engagementName
    }/Preprocess`,
    final_path: "",
    format: "",
  };
  const [formField, setFormField] = useState(INITIALSTATE);
  const [loading, setloading] = useState(false);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [instrumentData, setInstrumentData] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [errors, setErrors] = useState({ train: "", test: "" });

  const store = JSON.parse(sessionStorage.getItem("allNodes"));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField.preprocess_instrument_file);
          setFetchedHeader(node.fetchedHeader);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  const validate = () => {
    if (
      formField.pathTypeFile === "filepath" &&
      !formField.path.includes(".csv")
    ) {
      setErrors({ ...errors, filepath: "Enter valid file path" });
    } else if (
      formField.pathTypeFile === "outputpath" &&
      formField.path.includes(".csv")
    ) {
      setErrors({ ...errors, outputpath: "Enter valid folder path" });
    } else {
      setErrors({ filepath: "", outputpath: "" });
    }
  };

  useEffect(() => {
    validate();
  }, [formField.path, errors.filepath, errors.outputpath]);

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
    getAllInstruments();
  }, [nodeId]);

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();
    if (!formField.alias.match(nameRegex)) {
      enqueueSnackbar("Alias Contains Special Character!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });

      return;
    }
    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (
            count <= connectedNodes.length &&
            node.id === connectedNodes[count]
          ) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem("updatedNodes", JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes") || "[]");

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem("allNodes", JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: {
        preprocess_instrument_file: formField,
        alias: formField.alias,
      },
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem("node", JSON.stringify(nodes));
    sessionStorage.setItem("edges", JSON.stringify(edges));

    const fetchNodesData = JSON.parse(
      sessionStorage.getItem("allNodes") || "[]"
    );
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem("allNodes", JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(
      sessionStorage.getItem("saved_node") || "[]"
    );
    getElements.push(nodeId);
    sessionStorage.setItem("saved_node", JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes"));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el["disabled"] = false;
      }
    });

    sessionStorage.setItem("allNodes", JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem("saved_node"));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
  };

  const handleInstrumentName = (event) => {
    const selectedInstrument = instrumentData.find(
      (instrument) => instrument.instrument_name === event.target.value
    );
    setFormField({
      ...formField,
      instrument_name: event.target.value,
      final_path: `${formField.initial_path}`,
      format: selectedInstrument ? selectedInstrument.file_type : "",
    });
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  const getAllInstruments = async () => {
    try {
      setloading(true);
      const data = {
        user_id: userData.userId, // Provide the user_id
        search: false, // Set search to true if searchParam is provided
        searchParam: "", // Pass searchParam
        pagination: false,
      };
      const response = await InstrumentApi.getAllInstruments(axios, data);
      if (response.status === 200) {
        setInstrumentData(response.data.instrumentList);
      }
    } catch (error) {
      enqueueSnackbar("Internal Server Error!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setloading(false);
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        style={{ width: "70%", marginLeft: "30%" }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: "relative", backgroundColor: "#fff" }}>
            <Toolbar>
              <IconButton
                edge="start"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#00043C" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#00043C" }}
                variant="h6"
                component="div"
              >
                {nodeName}
              </Typography>
              <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <div style={{ margin: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField.alias}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <FormControl style={{ width: "100%", marginTop: "15px" }}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Instrument Name"
                    size="small"
                    value={formField.instrument_name}
                    onChange={handleInstrumentName}
                    disabled={disableForm}
                  >
                    {instrumentData.map((item) => {
                      if (
                        item.instrument_name ===
                        workflow.engagement.engagementName
                      )
                        return (
                          <MenuItem
                            key={item.instrument_name}
                            value={item.instrument_name}
                          >
                            {item.instrument_name}
                          </MenuItem>
                        );
                    })}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl style={{ width: "100%", marginTop: "15px" }}>
                  <TextField
                    id="outlined-select-currency"
                    label="Format"
                    size="small"
                    value={formField.format}
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <FormControl style={{ width: "100%", marginTop: "15px" }}>
                  <TextField
                    id="outlined-select-currency"
                    label="Path"
                    size="small"
                    value={
                      formField.final_path
                        ? formField.final_path
                        : formField.initial_path
                    }
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>
            {loading && (
              <Box>
                <LoadingIcon />
              </Box>
            )}
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalPreprocessInstrumentFile);
